import { useEffect, useState } from "react";
import axios from "axios";
import classes from "./Disposal.module.css";
import { env } from "../../constants/env";
import { useNavigate } from "react-router-dom";
import ReusableTable from "../ReusableTable/ReusableTable";
import { LuTrash2 } from "react-icons/lu";
import { toast } from "react-toastify";

const Disposal = () => {
  const navigate = useNavigate();
  const [docs, setDocs] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [search, setSearch] = useState("");

  const token = localStorage.getItem("formioToken");
  const payload = JSON.parse(localStorage.getItem("formioUser"));
  const role = payload?.data?.role;

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearch(searchTerm);
      setPage(1);
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchTerm]);

  useEffect(() => {
    fetchDocs();
  }, [page, search]);

  const fetchDocs = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${env.apiUrl}/api/submissions/stage/disposal`, {
        params: { page, limit, search },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setDocs(res.data.submissions);
      setCount(res.data.count);
    } catch (err) {
      console.error("Error fetching docs:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this document?"))
      return;

    try {
      setLoading(true);
      await axios.delete(`${env.apiUrl}/api/submissions/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      fetchDocs();
      toast.success("Document deleted successfully");
    } catch (err) {
      console.error("Error deleting document:", err);
      toast.error("Error deleting document");
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(count / limit);

  // Base columns for everyone
  const columns = [
    { key: "formName", label: "Document name", className: classes.docName },
    { key: "formTag1", label: "Document ref #" },
  ];

  // Add "Dispose" action column only if user is disposalManager
  if (role === "disposalManager") {
    columns.push({
      key: "formStage",
      label: "Action",
      render: (val, row) => (
        <div className={classes.actionCell}>
          <button
            className={`d-flex align-items-center gap-2 ${classes.deleteBtn}`}
            onClick={(e) => {
              e.stopPropagation();
              handleDelete(row._id);
            }}
          >
            <LuTrash2 size={20} /> Dispose
          </button>
        </div>
      ),
    });
  }

  return (
    <div className={classes.wrapper}>
      <h5>Documents Disposal</h5>
      <ReusableTable
        data={docs}
        loading={loading}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        page={page}
        limit={limit}
        count={count}
        totalPages={totalPages}
        setPage={setPage}
        onRowClick={(doc) =>
          navigate(`/activity/submitted-documents/${doc._id}`)
        }
        columns={columns}
      />
    </div>
  );
};

export default Disposal;